<template>
  <div>
    <div class="img-container" :style="'background-image:url(data:image/jpeg;base64,' + imgData.bgImg + ');'">
      <div
        v-if="visible"
        @mousedown="mousedownFn($event)"
        :class="['target-img', source + '-img']"
        :style="
          'left: ' +
          targetLeft +
          'px; top: ' +
          imgData.y +
          'px; background: url(data:image/jpeg;base64,' +
          imgData.cutoutImage +
          ') no-repeat'
        "
      ></div>
    </div>
    <div :class="['drag', source]" ref="dragDiv">
      <div class="drag_bg" :style="'width:' + dragWidth + 'px;'"></div>
      <div class="drag_text" :style="'color:' + textColor">{{ confirmWords }}</div>
      <div
        ref="moveDiv"
        @mousedown="mousedownFn($event)"
        :class="['handler', 'handler_bg', confirmSuccess ? 'handler_ok_bg' : '']"
        :style="'position: absolute; top: 0px; left:' + handleLeft + 'px; width:' + handleWidth + 'px;'"
      ></div>
    </div>
  </div>
</template>

<script>
import baseApi from '@/dss-common/api/base';

export default {
  name: 'SliderValidation',
  props: {
    source: {
      type: String,
      default: 'password',
    },
  },
  data() {
    return {
      beginClientX: 0 /** 距离屏幕左端距离 */,
      mouseMoveStata: false /** 触发拖动状态  判断 */,
      maxwidth: '' /* 拖动最大宽度，依据滑块宽度算出来的 */,
      confirmWords: '拖动滑块验证' /* 滑块文字 */,
      confirmSuccess: false /* 验证成功判断 */,
      targetLeft: 0,
      textColor: 'none',
      handleLeft: 0,
      handleWidth: 40,
      dragWidth: 0,
      visible: true,
      imgData: {
        bgImg: '',
        shadeImage: '',
        cutoutImage: '',
        originImage: '',
        redisKey: '',
        type: 'slide',
        x: 0,
        y: 0,
      },
    };
  },
  mounted() {
    this.init();
    this.queryVerifyCode();
  },
  methods: {
    init() {
      this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
      // 解决页面未被渲染时无法获取到滑块的width
      if (this.maxwidth !== 0) {
        localStorage.setItem('sliderWidth', `${this.maxwidth}`);
      }
      if (this.maxwidth === 0) {
        const width = localStorage.getItem('sliderWidth');
        this.maxwidth = width;
      }
      document.getElementsByClassName(this.source)[0].addEventListener('mousemove', this.mouseMoveFn);
      document.getElementsByClassName(this.source + '-img')[0].addEventListener('mousemove', this.mouseMoveFn);
      document.getElementsByClassName(this.source)[0].addEventListener('mouseup', this.moseUpFn);
      document.getElementsByClassName(this.source + '-img')[0].addEventListener('mouseup', this.moseUpFn);
    },
    async queryVerifyCode() {
      try {
        const { success, data } = await baseApi.queryVerifyCode({ type: 'slide' });
        if (success) {
          this.imgData = data;
          this.imgData.bgImg = data.shadeImage;
          console.log('imgData.y', this.imgData.y);
        }
      } catch (error) {}
    },
    // mousedoen 事件
    mousedownFn(e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault(); // 阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true;
        this.beginClientX = e.clientX;
      }
    },
    // 验证成功函数
    successFunction() {
      this.confirmSuccess = true;
      this.confirmWords = '验证通过';
      if (window.addEventListener) {
        document.getElementsByClassName(this.source)[0].removeEventListener('mousemove', this.mouseMoveFn);
        document.getElementsByClassName(this.source)[0].removeEventListener('mouseup', this.moseUpFn);
        document.getElementsByClassName(this.source + '-img')[0].removeEventListener('mousemove', this.mouseMoveFn);
        document.getElementsByClassName(this.source + '-img')[0].removeEventListener('mouseup', this.moseUpFn);
      } else {
        document.getElementsByClassName(this.source)[0].removeEventListener('mouseup', () => {});
        document.getElementsByClassName(this.source + '-img')[0].removeEventListener('mouseup', () => {});
      }
      this.textColor = '#fff';
      this.handleLeft = this.maxwidth;
      this.dragWidth = this.maxwidth;
    },
    // mousemove事件
    mouseMoveFn(e) {
      if (this.mouseMoveStata) {
        const width = e.clientX - this.beginClientX;
        if (width > 0 && width <= this.maxwidth) {
          this.handleLeft = width;
          this.targetLeft = width;
          this.dragWidth = width;
        }
        // else if (width > this.maxwidth) {
        //   this.successFunction();
        // }
      }
    },
    // mouseup事件
    moseUpFn(e) {
      this.mouseMoveStata = false;
      // const width = e.clientX - this.beginClientX;
      if (this.targetLeft > this.imgData.x - 4 && this.targetLeft < this.imgData.x + 4) {
        this.successFunction();
        this.$emit('verify-success', { x: this.imgData.x, y: this.imgData.y, captchaKey: this.imgData.redisKey });
        setTimeout(() => {
          this.imgData.bgImg = this.imgData.originImage;
          this.visible = false;
        }, 1000);
      } else {
        this.handleLeft = 0;
        this.dragWidth = 0;
        this.targetLeft = 0;
      }
    },
  },
};
</script>

<style scoped>
.img-container {
  position: relative;
  width: 100%;
  height: 150px;
  margin-bottom: 10px;
  background-repeat: no-repeat;
}
.target-img {
  position: absolute;
  width: 35px;
  height: 35px;
  z-index: 1000;
}

.drag {
  position: relative;
  background-color: #e8e8e8;
  width: 100%;
  height: 34px;
  line-height: 34px;
  text-align: center;
}
.handler {
  width: 40px;
  height: 32px;
  border: 1px solid #ccc;
  cursor: move;
}
.handler_bg {
  background: #fff url('../../../images/arrow-double-right.png') no-repeat center;
}
.handler_ok_bg {
  background: #fff url('../../../images/duigou.png') no-repeat center;
}
.drag_bg {
  background-color: #7ac23c;
  height: 34px;
  width: 0px;
}
.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  user-select: none;
}
</style>
